<template>
	<ContentGrid
		v-if="content.isContentGrid"
		:component="content"
		:dark="dark"
		:rows="rows"
	/>
	<ListIcons
		v-else
		:component="content"
		:dark="dark"
	/>
</template>

<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import SupportsDarkMode from "~/mixins/platform/SupportsDarkMode.js";

export default defineNuxtComponent({
	name: "TeaserReadMore",
	mixins: [GizmoComponentMixin, SupportsDarkMode],

	computed: {
		content() {
			const component = this.component;
			const useContentGrid = component.template.name.indexOf("big-images") > -1;

			if (useContentGrid) {
				return {
					isContentGrid: true,
					content: {
						largeHeading: true,
						heading: component.content.readMoreHeading,
						articles: component.content.readMoreArticles.map((article) => {
							let articleLink =
								article.readMoreArticleLink &&
								(article.readMoreArticleLink.externalUrl || article.readMoreArticleLink.internalUrl);
							if (!articleLink) articleLink = article.readMoreArticleTextHref;

							return {
								ingress: article.readMoreArticleText,
								image: {
									image_md: article.readMoreArticleImage,
									alt: article.readMoreArticleImage && article.readMoreArticleImage.alt,
								},
								internalLink: article.internalLink || article.internalUrl,
								externalLink: article.externalLink || article.externalUrl,
								articleLink: articleLink,
								heading: article.readMoreArticleHeading,
								center: true,
							};
						}),
						loadMore: component.content.loadMore,
						loadMoreText: component.content.loadMoreText,
						zoomImages: component.content.zoomImages,
					},
				};
			} else {
				return {
					content: {
						iconHeading: component.content.readMoreHeading,
						iconList: component.content.readMoreArticles.map((article) => {
							return {
								iconHeading: article.readMoreArticleHeading,
								iconImage: article.readMoreArticleImage,
								iconLink: article.readMoreArticleLink,
								iconText: article.readMoreArticleText,
								hideReadMore: true,
								paragraphSize: "s",
							};
						}),
					},
				};
			}
		},
		rows() {
			return Math.ceil(this.content.content.articles.length / 3);
		},
	},
});
</script>

<style lang="scss" scoped>
.list-icons :deep(.icons) {
	margin-bottom: 0;

	@media screen and (min-width: $size-screen-phone+1) {
		:deep(a.link-wrap) {
			padding-left: 130px;
			display: block;

			img {
				float: left;
				width: 114px;
				height: auto;
				margin-left: -130px;
				vertical-align: middle;
				margin-bottom: 0;
			}

			.content {
				text-align: left;
			}
		}
	}
}
</style>
